import { Pipe, PipeTransform } from '@angular/core';
import { Report } from '../../_models/reports';

@Pipe({ name: 'reportQueryFilter' })

export class ReportQueryFilterPipe implements PipeTransform {
  transform(reports: Report[], queryText: string, count?: number): any[] {
    if (!reports) return [];
    if (!queryText) return reports;
    queryText = queryText.trim().toLowerCase();
    return reports.filter(report => {
      if (report.reportName.toLowerCase().includes(queryText)) {
        return report;
      }
      if (report.reportGroup.toLowerCase().includes(queryText)) {
        return report;
      }
    });
  }
}
